import { useContext, useEffect, useState } from "react";
import { Button, Spinner, Modal, OverlayTrigger, Tooltip, Popover } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { TenantContext } from "../../context/tenant/TenantContext";
// import { ParamsContext } from "../../context/params/ParamsContext";
import "./offer.css";
import { ClientContext } from "../../context/client/ClientContext";
import { LanguageContext } from "../../context/language/LanguageContext";
import { CardContext } from "../../context/card/CardContext";
import OfferActivation from "./OfferActivation";
import { useCountdown } from "../../hooks/useCountdown";
import { useOfferActivation } from "../../hooks/useOfferActivation";
import { getValidityDates } from "../../utils/offerUtils";
import { useOfferState } from "../../hooks/useOfferState";
import DOMPurify from "dompurify";




export default function Offer({ offer, count, expire, loadingWithCard }) {
  const { tenant } = useContext(TenantContext);
  const { client } = useContext(ClientContext);
  // const { awsparams } = useContext(ParamsContext);
  const { card } = useContext(CardContext);

  const [showMessageModal, setShowMessageModal] = useState(false);
  const { language, languagedispatch } = useContext(LanguageContext);
  const params = useParams();
  const tenanturl = params.tenanturlpathname;

  const { validityText, isEndingSoon, isNew } = getValidityDates({
    offer,
    tenant,
    language,
  });
  // hook for countdown logic in offer activqation
  const {
    remainingTime,
    isUnderGap,
    activated,
    startCountdown,
    setActivated,
    cleanup,
    setIsUnderGap,
  } = useCountdown({ tenant });
  //hook to initialize offer state
  const {
    isAttrLoaded,
    isSingleActivation,
    singleOfferActivated,
    isUnlimitedReactivation,
    unlimitedOfferActivated,
    isFinalActivation,
    setSingleOfferActivated,
    setUnlimitedOfferActivated,
  } = useOfferState({
    offer,
    client,
    tenant,
    startCountdown,
    setActivated,
    setIsUnderGap,
  });
  //hook for offer activation logic
  const { loader, message, activateOffer } = useOfferActivation({
    offer,
    client,
    tenant,
    card,
    language,
    setActivated,
    isUnlimitedReactivation,
    setUnlimitedOfferActivated,
    isSingleActivation,
    setSingleOfferActivated,
    startCountdown,
  });

  // Cleanup effect
  useEffect(() => {
    return () => {
      cleanup();
    };
  }, [cleanup]);

  const closeMessageModal = () => {
    setShowMessageModal(false);
  };


  return (
    <div className="col-12 col-md-3">
      <div className="offercardlink position-relative">
        <Link
          to={`/${tenanturl}/offerdetail/${offer.id}`}
          className="text-decoration-none position-relative h-100 d-block"
        >
          <div className="offerGrid ">
            <div className="offerGridImage position-relative">
              <img
                src={(offer.images) ? offer.images[0] : ""}
                alt={offer.title}
                onError={(e) => {
                  // console.error("Image not found", e);
                  e.target.style.display = "none";
                }}
              />
              <div className="position-absolute end-0 top-0 mt-2 me-2 d-flex gap-1">
                <div className="badge rounded-pill of-badge text-uppercase">
                  {activated ? language?.static_labels.activated_pill : ""}
                </div>
                <div className="badge rounded-pill of-badge text-uppercase">
                  {isEndingSoon
                    ? language?.static_labels.ending_soon
                    : isNew
                      ? language?.static_labels.new
                      : ""}
                </div>
              </div>
            </div>
            <div className="offerGridContent">
              <div className="offerMerchant">

                {
                  (offer?.targetLevel === "MERCHANTS") ?
                    (offer.targetMerchants.length > 1) ?
                      <div className="row">
                        {
                          offer?.offerLogo === "" ?
                            <div className="merchantLogo d-inline w-auto agnostinc-offer ow-primary-blue"
                              style={{ backgroundImage: `url(${process.env.REACT_APP_CLOUDFRONT}icons/agnostic_merchant_offer.png)` }}>
                            </div>
                            :
                            <div className="merchantLogo d-inline w-auto">
                              <img
                                src={offer?.offerLogo}
                                alt={language?.static_labels.agnostic_merchant_offer}
                                className="rounded-circle"
                              />
                            </div>
                        }

                        <OverlayTrigger
                          delay={{ hide: 450, show: 300 }}
                          overlay={
                            <Popover id={`popover-positioned`}>
                              <Popover.Body>
                                {
                                  offer.targetMerchants.map((merch) => {
                                    return <div className="row pt-2 pb-2 ms-0 me-0 agnostic-bottom-border">
                                      <div className="agnostic-popoverLogo d-inline w-auto">
                                        <img
                                          src={merch.image}
                                          alt={offer.merchantDisplayName !== null ? offer.merchantDisplayName : merch.name}
                                          className="rounded-circle"
                                        />
                                      </div>
                                      <div className="col agnostic-popoverName text-truncate text-black">
                                        {offer.merchantDisplayName !== null ? offer.merchantDisplayName : merch.name}
                                      </div>
                                    </div>
                                  })
                                }
                              </Popover.Body>
                            </Popover>
                          }
                          placement="right"
                          trigger="hover"
                        ><button className={(offer?.offerLogo === "") ? "agnostic-offer-badge-common" : "agnostic-offer-badge-logo"}>
                            {offer.targetMerchants.length}
                          </button>
                        </OverlayTrigger>
                        <div className="col merchantName text-truncate text-black" title={offer.merchantDisplayName !== null ? offer.merchantDisplayName : language?.static_labels.agnostic_merchant_offer}>
                          {offer.merchantDisplayName !== null ? offer.merchantDisplayName : language?.static_labels.agnostic_merchant_offer}
                        </div>
                      </div>
                      : <div className="row">
                        <div className="merchantLogo d-inline w-auto">
                          <img
                            src={offer.targetMerchants[0]?.image}
                            alt={offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : offer.targetMerchants[0]?.name}
                            className="rounded-circle"
                          />
                        </div>
                        <div className="col merchantName text-truncate text-black" title={offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : offer.targetMerchants[0]?.name}>
                          {offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : offer.targetMerchants[0]?.name}
                        </div>
                      </div>
                    : (offer?.targetLevel === "CATEGORIES") ?
                      <div className="row">
                        {
                          offer?.offerLogo === "" ?
                            <div className="merchantLogo d-inline w-auto agnostinc-offer ow-primary-blue"
                              style={{ backgroundImage: `url(${process.env.REACT_APP_CLOUDFRONT}icons/agnostic_category_offer.png)` }}>
                            </div>
                            :
                            <div className="merchantLogo d-inline w-auto">
                              <img
                                src={offer?.offerLogo}
                                alt={offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : language?.static_labels.agnostic_category_offer}
                                className="rounded-circle"
                              />
                            </div>
                        }
                        <OverlayTrigger
                          delay={{ hide: 450, show: 300 }}
                          overlay={
                            <Popover id={`popover-positioned`}>
                              <Popover.Body>
                                {
                                  offer.targetCategories.map((merch) => {
                                    return language?.categories.map((category) => {
                                      if (category.category === merch.name) {
                                        return <div className="row pt-2 pb-2 ms-0 me-0 agnostic-bottom-border">
                                          <div className="agnostic-popoverLogo-category d-inline w-auto" >
                                            <img
                                              src={`${process.env.REACT_APP_CLOUDFRONT
                                                }categories/${DOMPurify.sanitize(
                                                  params.tenanturlpathname
                                                )}/${category.category.split("/").join("")}.svg`}
                                              alt={offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : merch.name}
                                              className="rounded-circle"
                                            />
                                          </div>
                                          <div className="col agnostic-popoverName text-truncate text-black">
                                            {offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : category.catalias}
                                          </div>
                                        </div>
                                      }
                                    })




                                  })
                                }
                              </Popover.Body>
                            </Popover>
                          }
                          placement="right"
                          trigger="hover"
                        ><button className={(offer?.offerLogo === "") ? "agnostic-offer-badge-common" : "agnostic-offer-badge-logo"}>
                            {offer.targetCategories.length}
                          </button>
                        </OverlayTrigger>
                        <div className="col merchantName text-truncate text-black" title={offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : language?.static_labels.agnostic_category_offer}>
                          {offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : language?.static_labels.agnostic_category_offer}
                        </div>
                      </div> :
                      (offer?.targetLevel === "CARDHOLDER") ?
                        <div className="row">
                          {
                            offer?.offerLogo === "" ?
                              <div className="merchantLogo d-inline w-auto agnostinc-offer ow-primary-blue"
                                style={{ backgroundImage: `url(${process.env.REACT_APP_CLOUDFRONT}icons/agnostic_cardholder_offer.png)` }}>
                              </div>
                              :
                              <div className="merchantLogo d-inline w-auto">
                                <img
                                  src={offer?.offerLogo}
                                  alt={offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : language?.static_labels.agnostic_cardholder_offer}
                                  className="rounded-circle"
                                />
                              </div>
                          }

                          <div className="col merchantName text-truncate text-black" title={offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : language?.static_labels.agnostic_cardholder_offer}>
                            {offer.merchantDisplayName && offer.merchantDisplayName !== null ? offer.merchantDisplayName : language?.static_labels.agnostic_cardholder_offer}
                          </div>
                        </div> : ""
                }



                <div className="offerTitle">{offer.title}</div>
                <div className="offerOptionslist">
                  <ul>
                    {offer.minimumSpend ? (
                      <li>
                        {language?.static_labels.minimum_spend} {offer.currency}{" "}
                        {offer.minimumSpend}
                      </li>
                    ) : (
                      ""
                    )}

                    {validityText && <li>{validityText}</li>}
                  </ul>
                </div>
                {/* <div className="onlineStore">
                        {(offer.salesChannel === "ALL") ? language?.static_labels.onlineandinstore
                            : (offer.salesChannel === "E-COMMERCE") ? language?.static_labels.online
                                : language?.static_labels.instore}
                    </div> */}
              </div>
            </div>
          </div>
        </Link>
        <div className="claimoffer position-absolute mt-5 w-100">
          <div className="onlineStore">
            {offer.salesChannel === "ALL"
              ? language?.static_labels.onlineandinstore
              : offer.salesChannel === "E-COMMERCE"
                ? language?.static_labels.online
                : language?.static_labels.instore}
          </div>
          <div>
            {offer.activationRequired && loadingWithCard ? (
              <div className="pe-3 ps-3">
                <Button disabled className="w-100 rounded-5">
                  <Spinner animation="border" variant="light" />
                </Button>
              </div>
            ) : (
              <OfferActivation
                offer={offer}
                isAttrLoaded={isAttrLoaded}
                client={client}
                activated={activated}
                singleOfferActivated={singleOfferActivated}
                remainingTime={remainingTime}
                isUnderGap={isUnderGap}
                activateOffer={activateOffer}
                tenanturl={tenanturl}
                language={language}
                tenant={tenant}
                isUnlimitedReactivation={isUnlimitedReactivation}
                unlimitedOfferActivated={unlimitedOfferActivated}
                isFinalActivation={isFinalActivation}
              />
            )}
          </div>
        </div>
      </div>
      <Modal
        show={showMessageModal}
        onHide={closeMessageModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {language?.static_labels.no_card_modal_title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{language?.static_labels.no_card_modal_message}</Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={closeMessageModal}>
                {language?.static_labels?.later}
            </Button> */}
          <Link to={`/${tenanturl}/user/mycards`} className="btn btn-secondary">
            {language?.static_labels.ok}
          </Link>
        </Modal.Footer>
      </Modal>
      {loader ? (
        <div className="ow-full-overlay">
          <div className="position-absolute ow-content-center text-center">
            <Spinner animation="border" backdrop="static" variant="light" />
            <h3 className="text-light">{message}</h3>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
